export default "__VITE_ASSET__COIQg58A__"